import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import UserContext from "../auth/UserContext";

const ProtectedRoute = ({ allowedRoles, component: Component, ...rest }) => {
    const { userDetail } = useContext(UserContext);
    // console.log("ProtectedRoute userDetail:", userDetail);
    return (
        <Route
            {...rest}
            render={(props) => (userDetail && allowedRoles.includes(userDetail.roleId) ? <Component {...props} /> : <Redirect to="/" />)}
        />
    );
};

export default ProtectedRoute;
